
<template>
    <div class="download-view">
        <div class="main-down">
           

            <div class="row">
    <div class="col">
        <div class="input-group mb-3">
                        <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">Date</span>
</div>
            <input v-model="StartDate" type="date" class="form-control" placeholder="Username"
                   aria-label="Username" aria-describedby="basic-addon1">
        </div>
    </div>                
</div>


            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">Racecourse</span>
                </div>
                <select v-model="RaceCourse" name="" class="form-control" id="">
                    <option v-for="race in raceCourses" :key="race" :value="race">
                        {{ race }}
                    </option>                  
                
                </select>
            </div>

            <button type="submit" @click="submit()" class="btn btn-primary btn-dark btn-full-width">Search</button>

        </div>

            
            <div v-show="showRacesAvailable && actionLinkData " class="list-data">


                <div  class=" mt-1 mb-1 dropdown show">
                    <a class="btn btn-secondary dropdown-toggle" @click="toggleDropdown()" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      EXPORT ALL
                    </a>
                  
                    <div v-bind:class="dropdownToggle" aria-labelledby="dropdownMenuLink">
                      
                      <a @click="openLink('XL')" class="dropdown-item" href="#">Excel</a>
                      <a @click="openLink('CSV')" class="dropdown-item" href="#">CSV</a>
                    
                    </div>
                </div>


            <ul class="list-group">
                <li class="list-group-item m-1 li-header" >
                <div class="row">
                   
                    <div class="col">Race Number</div>                    
                    <div class="col">Reports</div>
                </div>
                </li>

                <li v-for="item in actionLinkData" :key="item" class="list-group-item m-1">
                    <div class="row">                        
                        <div class="col">Race {{ item }}</div>
                                              
                        <div class="col"> <button @click="viewReport(item)" class="btn btn-dark">View Report</button></div>
                    </div>

                </li>
               
            </ul>
              
            
        </div>



    </div>
</template>

<script>



import { mapMutations,mapGetters } from 'vuex';
import {ReportingAndAnalyticsService} from '../services/reporting.service' ; 
import { config } from '../../config';

export default {
name : "DistanceCoveredFilter" , 
data() {
    return {
        StartDate: `${new Date().getFullYear()}-${new Date().getMonth()+1 > 9 ? new Date().getMonth() +1 :`0${new Date().getMonth()+1}`}-${new Date().getDate() > 9 ? new Date().getDate() : `0${new Date().getDate()}`}`,
            EndDate: null,
            RaceCourse: null,
            showRacesAvailable: false , 
            actionLinkData : [] ,
            noDataMessage : false,
            dropdownToggle:'dropdown-menu' , 
            dropdownStatus : false ,
            raceCourses : null 
    }
},
methods: {
    async submit(){

       
            var dataRetrieved = await ReportingAndAnalyticsService.getReportPositionBehindFilterScreen(this.StartDate, this.RaceCourse);

            this.actionLinkData = dataRetrieved.raceNumbers ; 

            this.showRacesAvailable = true;           

         


    } ,  
    async viewReport(raceNumber){
        this.setReportRacesArray(this.actionLinkData) ; 
        this.setReportRacecourse(this.RaceCourse) ; 
        this.setReportDate(this.StartDate) ; 
        this.setReportRN(raceNumber);
        var dataRetrieved = await ReportingAndAnalyticsService.getReportSectionalPosition(this.StartDate, this.RaceCourse , raceNumber);
         
        this.setReportSectioanl(dataRetrieved.resultData);
        this.setReportName(dataRetrieved.reportName) ; 
        this.setReportHeaderNames(dataRetrieved.headerNames) ; 




        this.$router.push('/landing/SectionalPositionReport') ; 


    }, 
    toggleDropdown(){
            this.dropdownStatus = !this.dropdownStatus ; 
            this.dropdownToggle = this.dropdownStatus ? "dropdown-menu show" :"dropdown-menu" ; 
        }
,
    openLink(fileType){
        
        window.open(`${config.reportingURL}/api/Reports/FileSectionalPositionBulk?raceCourse=${this.RaceCourse}&startDate=${this.StartDate}&fileType=${fileType}`, '_blank');


    }
    
    ,...mapMutations(["setReportSectioanl" , "setReportRN" , "setReportName","setReportHeaderNames","setReportRacecourse","setReportDate","setReportRacesArray"])
}, computed: {
        ...mapGetters([
            'getReportRaceDate','getReportRacecourse' , 'getReportRacesArray'
        ])
    },
async mounted(){

    var res = await ReportingAndAnalyticsService.getRaceCourseForDisplay() ; 
    this.raceCourses = res.resultData.map(x => x.raceCourseName.toUpperCase())  ; 
        

    this.StartDate =  this.getReportRaceDate ? this.getReportRaceDate : `${new Date().getFullYear()}-${new Date().getMonth()+1 > 9 ? new Date().getMonth() +1 :`0${new Date().getMonth()+1}`}-${new Date().getDate() > 9 ? new Date().getDate() : `0${new Date().getDate()}`}` ; 
        this.RaceCourse = this.getReportRacecourse ?  this.getReportRacecourse : '' ; 
        if(this.getReportRacesArray){

            this.actionLinkData =  this.getReportRacesArray ; 
            this.showRacesAvailable = true ; 

        }
}


}

</script>

<style scoped>
.btn-full-width {
    width: 100%;
}

.main-down {
    width: 95%;
    background-color: white;
    border-radius: 0.2rem;
    margin-inline: auto;
    margin-top: 1rem;
    padding: 1rem;
}

.li-header{
    color: white;
    background-color: black;
}

.list-data {
    width: 95%;
    background-color: white;
    border-radius: 0.2rem;
    margin-inline: auto;
    margin-top: 0.1rem;
    padding: 0.2rem;
}

.input-container {
    display: inline-block;
    position: relative;
}

.input-container input {
    border: none;
    box-sizing: border-box;
    outline: 0;
    padding: .75rem;
    width: 100%;
    height: 100%; /* Ensure the input field takes up the full height */
    position: relative;
    z-index: 1; /* Ensure the input field is clickable */
}

/* Hide the default calendar picker */
input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    color: transparent;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

</style>